<script setup lang="ts">
/** sub: shown as a muted second line; the heading still reads "title · sub". */
defineProps<{ n: number; title: string; sub?: string; lede?: string; eyebrow?: string }>();
</script>

<template>
  <header class="ph">
    <p class="ph-eyebrow">{{ eyebrow ?? `Step ${n} of 5` }}</p>
    <h1 id="panelTitle" class="ph-title" tabindex="-1">{{ title }}<template v-if="sub"><span class="sr-only"> · </span><span class="ph-sub">{{ sub }}</span></template></h1>
    <p v-if="lede" class="ph-lede">{{ lede }}</p>
  </header>
</template>
